export const ERROR_FLAG_ID = 'NOTIFICATIONS_CONFIG_ERROR_FLAG';
